import React, { useEffect } from "react";
import { Row, Col, Button } from "antd";
import Modal from "antd/lib/modal/Modal";
import konsole from "../network/konsole";
import { ModalBody } from 'react-bootstrap';

const SendEmailModal = (props) =>{

  useEffect(()=>{
    console.log("previewTemplateData",props?.previewTemplateData)
    document.getElementById("templateData").innerHTML=props?.previewTemplateData
  },[])

    const onCancel = () => {
      props.sendEmailStauts(false)
   props.cancelMOdal(false)
    };

    const submitData = () => {
   props.sendEmailStauts(true)
    };




    return(
        <>

<Modal visible={true} onCancel={onCancel} borderRadius={20} closable={false} footer={false} maskClosable={false} enforceFocus={false}
    width={1000} style={{ top: 20 }} bodyStyle={{ padding: '14px', maxHeight: 'calc(100vh - 80px)', overflowY: 'auto', borderRadius: '8px' }}>
        <ModalBody >
         <div  style={{ maxHeight: 'calc(100vh - 226px)', overflowY: 'auto',overflowX:'hidden' }}>
        <div
          style={{
            // border: "1px solid #720c20",
            width: "auto",
             margin: "1px",
            // backgroundColor: "#720c20",
            color: "white",
            display: "flex",
            justifyContent: "space-between",

          }}
          className="rounded-top"
        >
          <div className="fw-bolder" style={{ color: "#333333", fontSize:"18px"}}>Send Email Text</div>
          <div className="me-2 mt-1" style={{cursor: "pointer",color:'#333333',fontWeight:'700'}}  onClick={onCancel}>X</div>
        </div>
        <div style={{ borderBottom: "1px solid #BFBFBF", marginTop: "18px" }} />

        <br />
        <br />

        <div className="text-center w-auto" id="templateData">

        </div>
        </div>

        <Row className="justify-content-between" style={{ borderTop: "1px solid #BFBFBF", paddingTop: "24px", marginTop: "8px" }}>
          <Col>
            <Button
              style={{ backgroundColor: "white", color: "#720C20", border: "2px solid #720c20", borderRadius: "5px", padding:"4px 10px", height:"44px", minWidth:"90px"}} 
              onClick={onCancel}>
            Cancel</Button>
          </Col>
          <Col>
            <Button
              style={{ backgroundColor: "#720c20", color: "white", border: "none", borderRadius: "5px", height:"44px", minWidth:"90px"}}
              onClick={submitData}
            >Send</Button>
          </Col>
        </Row>
        </ModalBody>
      </Modal>

        </>
    )
}

export default SendEmailModal;